import {makeAutoObservable} from 'mobx';

export type ToastSeverity = 'success' | 'error' | 'warning' | 'info';

export interface ToastDetail {
    message: string;
    severity: ToastSeverity;
    duration?: number;
}

class ToastStore {
    currentToast: ToastDetail | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    showToast(detail: ToastDetail) {
        this.currentToast = detail;
    }

    clearToast() {
        this.currentToast = null;
    }
}

export const toastStore = new ToastStore();
